import React from 'react';
import styles from "../../../../styles/office/EditModal.module.css";

const DialogZone = ({
  language,
  formData,
  onChange,
  onCancel,
  onGenerate
}) => (
  <div className={styles.confirmationOverlay}>
    <div className={styles.surveyDialogCard}>
      <div className={styles.surveyDialogHeader}>
        <h3>{language === 'en' ? 'Zone Information' : 'सर्वे माहिती'}</h3>
      </div>

      <div className={styles.surveyDialogBody}>
        <div className={styles.surveyDialogGroup}>
          <label>
            {language === 'en' ? 'Last Zone Statement' : 'नाव'} <span className={styles.requiredIndicator}>*</span>
          </label>
          <input
            type="text"
            name="zoneStatement"
            onChange={onChange}
            className={styles.surveyDialogInput}
            placeholder={language === 'en' ? ' क्षेत्र शेती विभागात समाविष्ट आहे.' : 'आपले नाव प्रविष्ट करा'}
          />
        </div>
      </div>

      <div className={styles.surveyDialogActions}>
        <button onClick={onCancel} className={styles.surveyDialogCancel}>
          {language === 'en' ? 'Cancel' : 'रद्द करा'}
        </button>
        <button onClick={onGenerate} className={styles.surveyDialogGenerate}>
          {language === 'en' ? 'Confirm And Generate' : 'तयार करा'}
        </button>
      </div>
    </div>
  </div>
);

export default DialogZone;